module.exports = __webpack_public_path__ + "img/dlt_kind_8.86c01f2c.png";